/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Cais_TextInputs */

const en_home_quotes_cais_text = /** @type {(inputs: Home_Quotes_Cais_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitigating the risk of extinction from AI should be a global priority alongside other societal-scale risks such as pandemics and nuclear war.`)
};

/**
* | output |
* | --- |
* | "Mitigating the risk of extinction from AI should be a global priority alongside other societal-scale risks such as pandemics and nuclear war." |
*
* @param {Home_Quotes_Cais_TextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_cais_text = /** @type {((inputs?: Home_Quotes_Cais_TextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Cais_TextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_cais_text(inputs)
});